var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 16,
    viewBox: "0 0 5 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 11.9062C3.30469 11.9062 4.21875 12.8203 4.21875 13.875C4.21875 14.9648 3.30469 15.8438 2.25 15.8438C1.16016 15.8438 0.28125 14.9648 0.28125 13.875C0.28125 12.8203 1.16016 11.9062 2.25 11.9062ZM2.25 6.28125C3.30469 6.28125 4.21875 7.19531 4.21875 8.25C4.21875 9.33984 3.30469 10.2188 2.25 10.2188C1.16016 10.2188 0.28125 9.33984 0.28125 8.25C0.28125 7.19531 1.16016 6.28125 2.25 6.28125ZM2.25 4.59375C1.16016 4.59375 0.28125 3.71484 0.28125 2.625C0.28125 1.57031 1.16016 0.65625 2.25 0.65625C3.30469 0.65625 4.21875 1.57031 4.21875 2.625C4.21875 3.71484 3.30469 4.59375 2.25 4.59375Z",
    fill: "#0B213E"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore);
export default __webpack_public_path__ + "static/media/more.94dbe04d028f4457284b8e0dc56c6559.svg";
export { ForwardRef as ReactComponent };